module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    attrs: {
      "id": "sigil_toc_id_3",
      "title": "Copyright"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "ismall"
  }, [_vm._v("InterVarsity Press"), _c('br'), _vm._v("\n  P.O. Box 1400, Downers Grove, IL 60515-1426"), _c('br'), _vm._v("\n  World Wide Web: "), _c('a', {
    attrs: {
      "href": "http://www.ivpress.com",
      "target": "_blank"
    }
  }, [_vm._v("www.ivpress.com")]), _c('br'), _vm._v("\n  Email: "), _c('a', {
    attrs: {
      "href": "mailto:mailto:email%40ivpress.com?subject="
    }
  }, [_vm._v("email@ivpress.com")])]), _vm._v(" "), _c('p', {
    staticClass: "ismall"
  }, [_vm._v("©2014 by Kay Higuera Smith, Jayachitra Lalitha and L. Daniel Hawk")]), _vm._v(" "), _c('p', {
    staticClass: "ismall"
  }, [_vm._v("All rights reserved. No part of this book may be reproduced in any form without written permission from"), _c('br'), _vm._v("\n  InterVarsity Press.")]), _vm._v(" "), _c('p', {
    staticClass: "ismall"
  }, [_vm._v("InterVarsity Press® is the book-publishing division of InterVarsity Christian Fellowship/USA®, a movement of students and faculty active on campus at hundreds of universities, colleges and schools of nursing in the United States of America, and a member movement of the International Fellowship of Evangelical Students. For information about local and regional activities, write Public Relations Dept., InterVarsity Christian Fellowship/USA, 6400 Schroeder Rd., P.O. Box 7895, Madison, WI 53707-7895, or visit the IVCF website at "), _c('a', {
    attrs: {
      "href": "http://www.intervarsity.org",
      "target": "_blank"
    }
  }, [_vm._v("www.intervarsity.org")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "ismall"
  }, [_vm._v("Scripture quotations, unless otherwise noted, are from the New Revised Standard Version of the Bible, copyright 1989 by the Division of Christian Education of the National Council of the Churches of Christ in the USA. Used by permission. All rights reserved.")]), _vm._v(" "), _c('p', {
    staticClass: "ismall"
  }, [_vm._v("While all stories in this book are true, some names and identifying information in this book have been changed to protect the privacy of the individuals involved.")]), _vm._v(" "), _c('p', {
    staticClass: "ismall"
  }, [_vm._v("Cover design: Cindy Kiple")]), _vm._v(" "), _c('p', {
    staticClass: "ismall"
  }, [_vm._v("Images: Quaker Peace Testimony by Ron Waddams. Private Collection/The Bridgeman Art Library")]), _vm._v(" "), _c('p', {
    staticClass: "ismall"
  }, [_vm._v("ISBN 978-0-8308-9631-8 (digital)"), _c('br'), _vm._v("\n  ISBN 978-0-8308-4053-3 (print)")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-55681477","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/copyright.vue
// module id = 60
// module chunks = 0